/**
 * v2 mock — auto-rotating menu feature (Option 3).
 *
 * Markup contract (inside the drawer):
 *   <div data-ww-menu-feature data-ww-interval="3200">
 *     <div data-ww-feat-layer data-cat="Heels"> <img/> </div>  (2+ layers, first has .is-active)
 *     ...
 *     <span data-ww-feat-label>Heels</span>
 *   </div>
 *   <a data-ww-feat-pill data-cat="Heels" href="/collections/heels">Heels</a>  (one per category)
 *
 * Crossfades through the category images, ~3.2s each, infinite loop.
 * Pills: hover / focus jumps the feature to that category (desktop); tapping a
 * pill still follows its link to the collection (mobile). Pauses on hover /
 * touch / when the tab is hidden.
 *
 * Fail-safe: the first layer + first pill are server-rendered with .is-active,
 * so the feature shows correctly even if this module never runs. Reduced motion:
 * no auto-advance and (via CSS) no transitions — the first image just shows.
 */
(function () {
  if (window.__wwMenuFeatureInit) return;
  window.__wwMenuFeatureInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initOne(root) {
    if (root.__wwMenuFeature) return;
    root.__wwMenuFeature = true;

    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-ww-feat-layer]'));
    var label = root.querySelector('[data-ww-feat-label]');
    var n = layers.length;
    if (n < 2) return;

    // Pills may live just outside the feature container (sibling row).
    var scope = root.parentNode || document;
    var pills = Array.prototype.slice.call(scope.querySelectorAll('[data-ww-feat-pill]'));

    var cats = layers.map(function (l) {
      return l.getAttribute('data-cat');
    });
    var interval = parseInt(root.getAttribute('data-ww-interval'), 10) || 3200;
    var current = 0;
    var timer = null;

    function set(i) {
      current = (i + n) % n;
      layers.forEach(function (l, li) {
        l.classList.toggle('is-active', li === current);
      });
      pills.forEach(function (p, pi) {
        p.classList.toggle('is-active', pi === current);
      });
      if (label && cats[current]) label.textContent = cats[current];
    }

    function advance() {
      set(current + 1);
    }
    function start() {
      if (!timer && !reduce) timer = window.setInterval(advance, interval);
    }
    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    pills.forEach(function (p, pi) {
      // Desktop hover / keyboard focus jumps the feature and pauses rotation.
      p.addEventListener('pointerenter', function () {
        set(pi);
        stop();
      });
      p.addEventListener('focus', function () {
        set(pi);
        stop();
      });
      p.addEventListener('pointerleave', start);
      p.addEventListener('blur', start);
      // Tap: update the feature immediately; the link still navigates.
      p.addEventListener('pointerdown', function () {
        set(pi);
        stop();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('touchstart', stop, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    set(0);
    start();
  }

  function initAll() {
    document.querySelectorAll('[data-ww-menu-feature]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
